import React from 'react';
import { AlertTriangle } from 'lucide-react';

const DeleteUserModal = ({ 
  isOpen, 
  onClose, 
  selectedUser, 
  onConfirm, 
  isDeleting = false,
  getUserDisplayName 
}) => {
  if (!isOpen || !selectedUser) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
      <div className="bg-white rounded-lg p-6 max-w-md w-full mx-4">
        <div className="flex items-center mb-4">
          <AlertTriangle className="h-6 w-6 text-error-600 mr-3" />
          <h3 className="text-lg font-medium text-secondary-900">
            Delete User
          </h3>
        </div>
        <p className="text-sm text-secondary-600 mb-6">
          Are you sure you want to delete <strong>{getUserDisplayName(selectedUser)}</strong>?
          This action cannot be undone and will permanently remove all user data.
        </p>
        <div className="flex justify-end space-x-3">
          <button
            onClick={onClose}
            className="btn btn-outline"
          >
            Cancel
          </button>
          <button
            onClick={() => onConfirm(selectedUser._id)}
            disabled={isDeleting}
            className="btn btn-error"
          >
            {isDeleting ? 'Deleting...' : 'Delete User'}
          </button>
        </div>
      </div>
    </div>
  );
};

export default DeleteUserModal;